import { api } from "../api";

export interface AuditLogActor {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
}

export interface AuditLogEntry {
  id: string;
  action: string;
  resourceType: string;
  resourceId: string | null;
  description: string | null;
  createdAt: string;
  user: AuditLogActor | null;
  staff: AuditLogActor | null;
}

export interface GetAuditLogsParams {
  action?: string;
  resourceType?: string;
  module?: string;
  limit?: number;
}

export const auditApi = {
  getLogs: (params?: GetAuditLogsParams) =>
    api
      .get<AuditLogEntry[]>("audit/logs", {
        params: {
          action: params?.action,
          resourceType: params?.resourceType,
          module: params?.module,
          limit: params?.limit,
        },
      })
      .then((r) => r.data),
};
